module.exports = __webpack_public_path__ + "img/ben-2018.8713b593.jpeg";